import { createFileRoute } from "@tanstack/react-router"

import { HomePage } from "@/brand/components/home/home-page"
import { buildHead } from "@/core/seo"

import { HOME_COPY_ZH, HOME_SEO_ZH } from "../../content/zh/home"

/** Chinese home page, at /zh (D-WEB-LANG-SCOPE); the English route carries the hreflang pair too. */
export const homeZhSeo = () => buildHead({ ...HOME_SEO_ZH, path: "/", localePrefix: "zh" })

export const Route = createFileRoute("/_brand-layout/zh")({
  head: () => {
    const { meta, links, scripts } = homeZhSeo()
    return { meta, links, scripts }
  },
  component: HomeZhPage,
})

export function HomeZhPage() {
  return <HomePage copy={HOME_COPY_ZH} />
}
